import { useForm } from 'app/hooks/form';
import { useRoute } from 'app/hooks/navigation';
import { env } from 'app/lib/env';
import { getI18nLanguage } from 'app/lib/language';
import 'app/lib/form';
import { i18n } from 'app/localization/i18n';
import type { CreateUserDTO, UserType } from 'app/types/user';

import * as yup from 'yup';

export type CredentialsFormSchema = CreateUserDTO & {
  passwordConfirmation: string;
  inviteCode?: string | null;
  language?: string;
  type?: string | null;
};

export function useCredentialsForm(requireActivationCode: boolean) {
  const route = useRoute<'credentials'>();
  const i18nLanguage = getI18nLanguage();
  const userType = route.params?.userType as UserType | undefined;

  const schema: yup.ObjectSchema<CredentialsFormSchema> = yup.object({
    email: yup.string().email().required(),
    password: yup.string().password().required(),
    passwordConfirmation: yup
      .string()
      .oneOf([yup.ref('password')], i18n.t('passwordErrorMatching', { ns: 'common' }))
      .required(),
    inviteCode: yup
      .string()
      .default(null)
      .when({
        is: () => requireActivationCode,
        then: (s) => s.required(),
        otherwise: (s) => s.optional().nullable(),
      }),
    language: yup.string(),
    type: yup.string().optional().nullable(),
  });

  return useForm<CredentialsFormSchema>({
    defaultValues: {
      inviteCode: route.params?.inviteCode,
      language: i18nLanguage,
      type: userType,
      ...(env.APP_ENV === 'local'
        ? {
            ...(env.DEFAULT_USERNAME && { email: env.DEFAULT_USERNAME }),
            ...(env.DEFAULT_PASSWORD && {
              password: env.DEFAULT_PASSWORD,
              passwordConfirmation: env.DEFAULT_PASSWORD,
            }),
          }
        : {}),
    },
    schema,
  });
}
